export default __webpack_public_path__ + "static/media/home.7cda370e.svg";